<template>
  <div class="home-div">
    <SideBar />
    <vueDanmaku ref="danmaku" v-model="danmus" :use-slot="useSlot" loop :top="20" :right="40" :speeds="50"
      :channels="channelCount" :randomChannel="true" class="danmaku-div">
      <template slot="dm" slot-scope="{ danmu }">
        <div class="dm-info font-color-5">
          <img class="dm-img" :src="danmu.avatar" />
          {{ danmu.text }}
        </div>
      </template>
    </vueDanmaku>
    <div class="dm-send">
      <input class="dm-inp font-color-5 mbl-no-hover" v-model="dmInfo" placeholder="不防停留片刻，留下点什么？" />
      <div class="dm-but font-color-5 mbl-no-hover" @click="addDanmaku()">发送</div>
    </div>
    <!-- <BottomTip class="tip" /> -->
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import vueDanmaku from 'vue-danmaku';
import { Message } from 'element-ui';

import { getDanmakuList, saveDanmaku } from '@/api/danmaku.js';

export default {
  name: 'Danmaku',
  components: {
    SideBar,
    BottomTip,
    vueDanmaku
  },
  data() {
    return {
      dmInfo: '',
      useSlot: true, // 是否开启slot
      isFullscreen: false,
      currentFullscreenImage: '',
      danmus: [],
      channelCount: 10,
      colors:[
  "#73A6D2", // 暖调天蓝（主色）
  "#A6C4A0", // 暖调抹茶绿（辅色）
  "#C9A3D6", // 暖调淡紫（点缀）
  "#8ECAE6", // 浅天蓝色（清爽，不抢戏）
  "#B7E4C7"  // 浅薄荷绿（柔和，低存在感）
]
    }
  },
  async mounted() {
    await this.getDanmakuListInfo();
    this.updateChannelsByScreen();
    window.addEventListener('resize', this.updateChannelsByScreen);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateChannelsByScreen);
  },
  methods: {
    updateChannelsByScreen() {
      // 根据屏幕宽度动态设置通道数
      const screenWidth = window.innerWidth;
      
      if (screenWidth < 1024) {
        this.channelCount = 11;
      } else { // 桌面端
        this.channelCount = 10;
      }
      
      // 如果需要重新初始化弹幕组件
      if (this.$refs.danmaku && this.$refs.danmaku.reset) {
        this.$refs.danmaku.reset();
      }
    },
    getRandomColor() {
      const randomIndex = Math.floor(Math.random() * this.colors.length);
      return this.colors[randomIndex];
    },
    async getDanmakuListInfo() {
      const resp = await getDanmakuList();
      if (resp.data != null) {
        this.danmus = resp.data;
      }
    },
    addDanmaku() {
      if (!this.dmInfo){
        Message.error('弹幕内容不能为空哦！');
        return;
      }
      if (this.dmInfo.length > 52) {
        Message.error('弹幕内容不能超过50字哦！');
        return;
      }
      const value = this.dmInfo;
      // 发送后端请求
      try {
        saveDanmaku(value);
      } catch(error){
        Message.error('弹幕发送失败，请稍后再试！');
        return;
      }
      const dmInfo = this.useSlot
        ? {
          avatar: 'https://i.loli.net/2021/01/17/xpwbm3jKytfaNOD.jpg',
          text: this.dmInfo,
        }
        : this.dmInfo
      this.$refs.danmaku.add(dmInfo);
      this.dmInfo = '';
      Message.success('弹幕已发送！');
    }
  }
}
</script>

<style scoped>

.dm-inp::placeholder{
  color: var(--font-color-5);
  font-size: 16px;
  padding-left: 10px;
}

@media(max-width: 768px) {
  .dm-send {
    bottom: 40px !important;
    width: calc(100% - 18px) !important;
  }

  .dm-inp {
    width: 100% !important;
  }
  
}

.mbl-no-hover {
  /* iOS风格毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.1);
  /* 提高透明度 */
  backdrop-filter: blur(16px) saturate(180%);
  /* 增加模糊和饱和度 */
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  /* 添加微妙的边框效果增强层次感 */
  border: 1px solid rgba(255, 255, 255, 0.3);
  /* 更柔和的阴影 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

  transition: all 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.dm-inp {
  width: 400px;
  height: 36px;
  font-size: 18px;
  border-radius: 50px;
  border: none;
}

.dm-but {
  width: 100px;
  height: 40px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  border-radius: 50px;
  margin-left: 2px;
}

.dm-send {
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 20px;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding-left: 10px;
  padding-right: 10px;
}

.dm-img {
  width: 30px;
  height: 30px;
  border-radius: 50px;
}

.dm-info {
  display: flex;
  align-items: center;
  border-radius: 50px;
  padding-right: 5px;
  font-size: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.6);
  background-color: rgba(0, 0, 0, 0.6);
}

.danmaku-div {
  width: 100%;
  height: 100%;
  margin-top: 40px;
}

.home-div {
  width: 100%;
  height: calc(100vh - 60px);
  margin: 0;
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
